import { defineMessages } from '@formatjs/intl';

export default defineMessages({
	backToMainMenu: {
		id: 'nav.mobileMenu.backToMainMenu',
		defaultMessage: 'Back to main menu',
		description: 'Accessible label for the button that leaves a submenu in the mobile navigation menu',
	},
});
